(function () {
    'use strict';

    angular.module("imApp").factory("orderLineCancelCauseLangService", ['$ihttp', function ($ihttp) {
        let service = {
            listOrderLineCancelCauseLanguages: function (parms) {
                return $ihttp.post({
                    method: 3329,
                    parameters: parms || {}
                });
            },
            saveObj: function (list) {
                return $ihttp.post({
                    method: 3330,
                    parameters: list
                });
            }
        };

        return service;
    }]);
})();
